import { API_FULL_URLS } from "../apiUrls";

export const surveyQuestionUnitTestConstants = {
  SURVEY: /survey/i,
  TEXT_BOX: /Textbox/i,
  NEW_BUTTON_NAME: /new/i,
  IRIS_STORE_NAME: /iris/i,
  ADD_BUTTON_NAME: /add/i,
  BRANDS_NAVLINKS: /brands/i,
  SAVE_BUTTON_NAME: /save/i,
  K_STORE_NAME: /k restaurant/i,
  CANCEL_BUTTON_NAME: /cancel/i,
  CLOSE_BUTTON_NAME: /^close$/i,
  UPDATE_BUTTON_NAME: /update/i,
  STAR_RANKING: /Star Ranking/i,
  DISCARD_BUTTON_NAME: /discard/i,
  PAGE_TITLE: /survey questions/i,
  TEST_ADD_GROUP: /test add group/i,
  TOGGLE_BODY_TESTID: /toggle-body/i,
  PREVIEW_SURVEY_ROUTE: "/preview-survey",
  NOTIFICATIONS_BUTTON: /Notifications:/i,
  RECEIVE_RESPONSES_BUTTON: /Receive Response/i,
  SURVEY_QUESTION_TESTID: /survey-questions/i,
  RECIPIENTS_MODAL_HEADING: /add recipients/i,
  TEST_TEXTBOX_QUESTION: "How was your food?",
  SURVEY_QUESTION_NAVLINK: /survey questions/i,
  ADD_NEW_QUESTION_TESTID: /add-new-question/i,
  MANAGER_DROPDOWN_TESTID: /manager-dropDown/i,
  STORE_NOT_LINKED_TESTID: /stores-not-linked/i,
  PREVIEW_SURVEY_BUTTON_TEXT: /preview survey/i,
  ALL_RESPONSES_MODAL_SEARCH: /search recipients/i,
  FRANCHISE_DROPDOWN_TESTID: /franchise-dropDown/i,
  SEARCH_ALL_RESPONSE_VALUE: "ali-ba@mailinator.com",
  ALL_RESPONSES_EMAIL_TESTID: /all-responses-emails/i,
  ADD_RECIPIENTS_EMAIL_TESTID: /add-recipients-emails/i,
  USER_EMAIL_PREFRENCES_TESTID: /user-email-prefrences/i,
  ADD_SECONDARY_TEXT_BOX_TESTID: /add-secondary-textbox/i,
  REMOVE_SURVEY_QUESTION_TESTID: /remove-survey-question/i,
  REMOVE_SECONDARY_TEXT_BOX_TESTID: /remove-secondary-textbox/i,
  REMOVE_TAG_BUTTON_TEST_ID: /removeTagButton/i,
  SURVEY_GET_CALL_FOR_SURVEY_BRAND: `${API_FULL_URLS.SURVEY.BASE}/10072`,
  SURVEY_GET_CALL_FOR_KHAN_BRAND: `${API_FULL_URLS.SURVEY.BASE}/10073`,
  ADD_NEW_QUESTION_CONTAINER_TESTID: /add-new-question-container/i,
  SURVEY_POST_ENDPOINT: `${API_FULL_URLS.SURVEY.BASE}/10072`,
  TEST_STAR_RANKING_QUESTION: "How was your online ordering experience?",
  PREVIEW_SURVEY_WARNING_MODAL_TEXT:
    /there are some unsaved changes\. either save or discard changes to access preview\./i,
  ADD_NEW_USER_MODAL_DESCRIPTION:
    /A verification Email will be sent to the new user who will be required to complete registration prior to receiving survey responses/i,
  EDIT_EMAIL_PREFRENCES_DESCRIPTION:
    /designate which groups or individual location will send notifications based on completed surveys\. all notifications will abide to the positive or negative settings established\./i,
};

export const surveyQuestionTabsName = {
  inStore: "In-Store",
  onlineOrder: "Online Order",
};
